import { Component, OnInit } from '@angular/core';
import { CourseConstants } from '../constants/course.constants'
import { CourseService } from '../services/course.service';
import { CourseCatalogueAuthorizationFlags } from '../models/courseCatalogueAuthorizationFlags';
import { LabelConstants } from '../../shared/constants/label-constants';

@Component({
  selector: 'app-course-library',
  templateUrl: './course-library.component.html',
  styleUrls: ['./course-library.component.scss']
})
export class CourseLibraryComponent implements OnInit {
  topBarTitle: string = CourseConstants.TopBarTitle_CourseCatalogue;
  isCourseSliderOpen = false;
  accessToCourseCatalogue: boolean = false;
  addCourseAccess: boolean = false;
  courseErrorMessage!:string;
  panelListScreen : string = CourseConstants.CourseLibraryScreen;
  constructor(private courseService : CourseService){

  }

  ngOnInit(): void {
    this.courseService.getCourseCatalogueAuthorisation().subscribe({
      next: (serviceData) => (this.accessToCourseCatalogue = serviceData.courseCatalogueAvailable, this.addCourseAccess = serviceData.addCourseAvailable),
      error: (err) => {
        this.accessToCourseCatalogue = false;
        if(err.status === LabelConstants.Forbidden_StatusCode)
          this.courseErrorMessage = err.error.detail;
      }        
    })
  }
 
  addCourse(){
    this.isCourseSliderOpen=!this.isCourseSliderOpen;
  }

  closeCourseSlider(isSliderActive : boolean){
    this.isCourseSliderOpen = isSliderActive;
  }

  courseCatalogueErrorMessage() : string{
    if (!this.accessToCourseCatalogue) {
      return this.courseErrorMessage;
    }
    return CourseConstants.Course_RoleAcessPermission_Fail;
  }
}

